import React from 'react';

interface DisplaySettingsProps {
  responsive: boolean;
  lazyLoad: boolean;
  onChange: (field: string, value: boolean) => void;
}

export const DisplaySettings: React.FC<DisplaySettingsProps> = ({
  responsive,
  lazyLoad,
  onChange,
}) => {
  return (
    <div className="mt-6 pt-6 border-t border-gray-200">
      <h3 className="text-sm font-medium text-gray-900 mb-4">Display Settings</h3>
      <div className="space-y-2">
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={responsive}
            onChange={e => onChange('responsive', e.target.checked)}
            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700">Responsive (scales to container width)</span>
        </label>
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={lazyLoad}
            onChange={e => onChange('lazyLoad', e.target.checked)}
            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700">Lazy load (improves page speed)</span>
        </label>
      </div>
    </div>
  );
};
